import { RootState } from "../../app/state";
import { createSelector } from "@reduxjs/toolkit";

export const selectFilterSlice = (state: RootState) => state.filterState;

export const selectInfluenceAreaEnabled = createSelector(
  selectFilterSlice,
  (state) => state.influenceAreaEnabled
);

export const selectShowIndoorDeviceList = createSelector(
  selectFilterSlice,
  (state) => state.showIndoorDeviceList
);

export const selectSmartFilterDeviceId = createSelector(
  selectFilterSlice,
  (state) => state.smartFilterDeviceIdList
);

export const selectCoordinatesFilter = createSelector(
  selectFilterSlice,
  (state) => state.coordinatesFilter
);

export const selectFilterPanelVisibility = createSelector(
  selectFilterSlice,
  (state) => state.filterPanelShown
);

export const selectCurrentManualFilters = createSelector(
  selectFilterSlice,
  (state) => state.manualFilters
);

export const selectFilterMapId = createSelector(
  selectFilterSlice,
  (state) => state.filtersAppliedForMapId
);

export const selectCurrentCoverageParams = createSelector(
  selectFilterSlice,
  (state) => state.coverageSettings
);

export const selectIsCoverageParamsSet = createSelector(
  selectCurrentCoverageParams,
  (coverageSettings) => coverageSettings.powerLossCoefficient !== null && coverageSettings.interferenceLevel !== null
);

